export interface IError {
  error: string;
}

export const isError = (item: any): item is IError => (item as IError).error !== undefined;
